import React from "react";
import { CogLoader } from "./CogLoader";
import styles from "./LoadingScreen.module.css";

interface LoadingScreenProps {
  type: "loading" | "error";
  appName?: string;
  errorMessage?: string;
}

export const LoadingScreen: React.FC<LoadingScreenProps> = ({
  type,
  appName,
  errorMessage,
}) => {
  if (type === "error") {
    return (
      <div className={styles.errorContainer}>
        <div className={styles.errorBox}>
          <h2 className={styles.errorTitle}>{appName ? `Failed to load ${appName}` : "Failed to load app"}</h2>
          {errorMessage && (
            <p className={styles.errorContent}>{errorMessage}</p>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <CogLoader width={48} />
      <p className={styles.loadingText}>
        {appName ? `Loading ${appName}...` : "Loading app..."}
      </p>
    </div>
  );
};
